/* more-indicator.tsx generated by @compiled/babel-plugin v0.35.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId", "className", "ref"];
import "./more-indicator.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef, useCallback } from 'react';
import Avatar from '@atlaskit/avatar';
import { fg } from '@atlaskit/platform-feature-flags';
var B300 = '#0065FF';
var B400 = '#0052CC';
var B50 = '#DEEBFF';
var N0 = '#FFFFFF';
var N20 = '#F4F5F7';
var N30 = '#EBECF0';
var N500 = '#42526E';
var buttonSizes = {
  small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var buttonActiveStyles = null;
var buttonStyles = null;
var MAX_DISPLAY_COUNT = 99;
var MoreIndicator = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance,
    _ref$borderColor = _ref.borderColor,
    borderColor = _ref$borderColor === void 0 ? fg('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-border-inverse, ".concat(N0, ")") : _ref$borderColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 0 : _ref$count,
    testId = _ref.testId,
    onClick = _ref.onClick,
    ariaControls = _ref['aria-controls'],
    ariaExpanded = _ref['aria-expanded'],
    ariaHaspopup = _ref['aria-haspopup'],
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
    isActive = _ref.isActive;
  var onClickHander = useCallback(function (event, analyticsEvent) {
    if (buttonProps.onClick) {
      buttonProps.onClick(event);
    }
    onClick(event, analyticsEvent);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [buttonProps.onClick, onClick]);
  return /*#__PURE__*/React.createElement(Avatar, {
    appearance: appearance,
    size: size,
    borderColor: borderColor,
    ref: ref,
    onClick: onClickHander
  }, function (_ref2) {
    var _ = _ref2.testId,
      className = _ref2.className,
      ref = _ref2.ref,
      props = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement("button", _extends({
      type: "submit"
    }, buttonProps, props, {
      ref: ref,
      "data-testid": testId,
      "aria-controls": ariaControls,
      "aria-expanded": ariaExpanded,
      "aria-haspopup": ariaHaspopup
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,

      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
      className: ax(["_16hglslw _1w901hoq _u1mbaek3 _1fh11hoq _10fu1kgi _1l5a17km _c6d7glyw", isActive && "_16hg1kxl _so1ehi7p _1w90ln51 _1g4l1np6 _u1mbg85j _1fh13htb _10fu1smf _1l5aln51", className]),
      style: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: buttonSizes[size],
        "--_1jkcdu5": ix("var(--ds-background-neutral, ".concat(N20, ")")),
        "--_h5fhc4": ix("var(--ds-text, ".concat(N500, ")")),
        "--_hz7h6s": ix("var(--ds-background-neutral-hovered, ".concat(N30, ")")),
        "--_1axggjc": ix("var(--ds-background-neutral-pressed, ".concat(B50, ")")),
        "--_1lrmnoy": ix("var(--ds-text, ".concat(B400, ")")),
        "--_rryx0a": ix("var(--ds-background-selected, ".concat(B50, ")")),
        "--_1t841jg": ix("0 0 0 2px ".concat("var(--ds-border-selected, ".concat(B300, ")"))),
        "--_1hfkvbo": ix("var(--ds-text-selected, ".concat(B400, ")")),
        "--_rkvepi": ix("var(--ds-background-selected-hovered, ".concat(N30, ")")),
        "--_ph2vs": ix("var(--ds-text-selected, ".concat(N500, ")")),
        "--_ohg1x3": ix("var(--ds-background-selected-pressed, ".concat(B50, ")"))
      }
    }), "+", count > MAX_DISPLAY_COUNT ? MAX_DISPLAY_COUNT : count);
  });
});
MoreIndicator.displayName = 'MoreIndicator';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default MoreIndicator;